import sample_1 from './NUG_Ideal_Articlepage.jpg';
import sample_2 from './NUG_Ideal_Broschure.jpg';

export const nugidealImpressions = {
    sample_1,
    sample_2,
};
